import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiDocStyles } from '../styles/apiDocStyles';

const FieldTable = ({ fields, type = 'request' }) => {
  const { t } = useTranslation();

  if (!fields || fields.length === 0) {
    return null;
  }

  return (
    <table style={apiDocStyles.fieldTable}>
      <thead>
        <tr>
          <th style={apiDocStyles.tableHeader}>{t('apiDoc.fieldName')}</th>
          <th style={apiDocStyles.tableHeader}>{t('apiDoc.fieldType')}</th>
          <th style={apiDocStyles.tableHeader}>{t('apiDoc.description')}</th>
        </tr>
      </thead>
      <tbody>
        {fields.map((field, index) => (
          <tr key={index}>
            <td style={apiDocStyles.tableCell}>
              <span style={apiDocStyles.fieldName}>{field.name}</span>
              {type === 'request' && field.required !== undefined && (
                field.required ? (
                  <span style={apiDocStyles.requiredBadge}>*{t('apiDoc.required')}</span>
                ) : (
                  <span style={apiDocStyles.optionalBadge}>{t('apiDoc.optional')}</span>
                )
              )}
            </td>
            <td style={apiDocStyles.tableCell}>
              <span style={apiDocStyles.fieldType}>{field.type}</span>
            </td>
            <td style={apiDocStyles.tableCell}>
              {field.description}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default FieldTable;
